import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// ✅ Add token automatically to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");
    if (token) {
      config.headers.token = token;
      // لو الباك بيستخدم Authorization بدل token:
      // config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
